export const emojis = [
  '😂',
  '😭',
  '😁',
  '😊',
  '😉',
  '👍',
  '👏',
  '👐',
  '🙏',
  '👌',
  '✌',
  '👌',
  '💪',
  '😍',
  '😘',
  '❤',
  '💔',
  '🎉',
  '👑',
  '🚀',
];

export const newEmojis = [
  {
    name: '🙂',
    link: 'https://statics.teams.cdn.office.net/evergreen-assets/skype/v2/smile/50.png?v=4',
    code: '#[1]',
  },
  {
    name: '😁',
    link: 'https://statics.teams.cdn.office.net/evergreen-assets/skype/v2/laugh/50.png?v=4',
    code: '#[2]',
  },
  {
    name: '😉',
    link: 'https://statics.teams.cdn.office.net/evergreen-assets/skype/v2/wink/50.png?v=4',
    code: '#[3]',
  },
  {
    name: '🙁',
    link: 'https://statics.teams.cdn.office.net/evergreen-assets/skype/v2/sad/50.png?v=4',
    code: '#[4]',
  },
  {
    name: '😭',
    link: 'https://statics.teams.cdn.office.net/evergreen-assets/skype/v2/cry/50.png?v=4',
    code: '#[5]',
  },
  {
    name: '😂',
    link: 'https://statics.teams.cdn.office.net/evergreen-assets/skype/v2/cwl/50.png?v=4',
    code: '#[6]',
  },
  {
    name: '😡',
    link: 'https://statics.teams.cdn.office.net/evergreen-assets/skype/v2/angryV2/50.png?v=4',
    code: '#[7]',
  },
  {
    name: '👋',
    link: 'https://statics.teams.cdn.office.net/evergreen-assets/skype/v2/hi/50.png?v=4',
    code: '#[8]',
  },
  {
    name: '🤦‍♀️',
    link: 'https://statics.teams.cdn.office.net/evergreen-assets/skype/v2/facepalm/50.png?v=4',
    code: '#[9]',
  },
  {
    name: '🎉',
    link: 'https://statics.teams.cdn.office.net/evergreen-assets/skype/v2/party/50.png?v=4',
    code: '#[10]',
  },
  {
    name: '❤️',
    link: 'https://statics.teams.cdn.office.net/evergreen-assets/skype/v2/heart/50.png?v=4',
    code: '#[11]',
  },
  {
    name: '😎',
    link: 'https://statics.teams.cdn.office.net/evergreen-assets/skype/v2/cool/50.png?v=4',
    code: '#[12]',
  },
  {
    name: '🎉2',
    link: 'https://statics.teams.cdn.office.net/evergreen-assets/skype/v2/holidayspirit/50.png?v=4',
    code: '#[13]',
  },
  {
    name: '👏',
    link: 'https://statics.teams.cdn.office.net/evergreen-assets/skype/v2/clap/50.png?v=4',
    code: '#[14]',
  },
  {
    name: '🌞',
    link: 'https://statics.teams.cdn.office.net/evergreen-assets/skype/v2/sun/50.png?v=4',
    code: '#[15]',
  },
];
